import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { ServiceSearchQueryContext } from "../../../contexts/ServiceSearchQueryContext";

export default function ServicesLink({ handleImageLoad }) {
  const [isLoaded, setIsLoaded] = useState(false);
  const { setCurrentPage } = useContext(ServiceSearchQueryContext);
  const handleImageLoaded = () => {
    setIsLoaded(true);
    handleImageLoad("servicesFrame");
  };

  const handleClick = () => {
    setCurrentPage(1);
  };
  return (
    <Link
      to={"/services"}
      className="relative w-[90dvw] mx-auto"
      onClick={handleClick}
    >
      {/* Loading indicator */}
      {/* {!isLoaded && (
        <div className="absolute inset-0 flex justify-center items-center bg-gray-500">
          Loading...
        </div>
      )} */}
      <img
        src="./images/services-frame.webp"
        alt="services frame preloader"
        className="hidden"
        onLoad={handleImageLoaded}
      />
      {isLoaded && (
        <>
          <img
            src="./images/services-frame.webp"
            alt="services frame"
            className="h-full w-[100dvw]"
            loading="lazy"
          />
          <div className="absolute top-0 bottom-0 flex flex-col justify-center gap-[0.8dvh] my-auto right-[3dvh]">
            <h1 className="text-black text-[2.3dvh] font-bold text-center capitalize">
              services
            </h1>
            <button className="text-white bg-[#A4907C] text-[1.7dvh] py-[.8dvh] px-[2.6dvh] font-bold rounded-[0.8dvh] capitalize">
              book now
            </button>
          </div>
        </>
      )}
    </Link>
  );
}
